export default function treeService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};

    const element = engineApi.register.setCommonAttributes('fb-tree', viewField, engineApi, { setDisabled: true }).addAttributes({
      'view-property-key': engineApi.dispatcher.set(viewField, `${viewField.name}_viewProperty`),
      'engine-api-key': engineApi.dispatcher.set(engineApi, `${viewField.name}_engineApi`),
    });

    if (engineApi.options.isReadOnly) {
      element.addAttribute('readonly', '');
    }

    return element;
  };
}
